import { useRealTimeStore } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';
import { Store } from '../../../store/player/types';
import { jumpTo } from './jumpTo';

export const forward = (store: Store, ms: number): void => {
  const { recording } = store.getState();
  if (!recording) return;

  const currentTime = useRealTimeStore.getState().currentTime;

  if (currentTime > 0) {
    jumpTo(store, Math.min(currentTime + ms, recording.duration));
  }
};
